export const formsProps = {
    name: String,
    gaName: String,
    aboutYou: {
        title: String,
        firstName: {
            placeholder: String,
            label: String
        },
        lastName: {
            placeholder: String,
            label: String
        },
        role: {
            placeholder: String,
            label: String
        },
        phone: {
            placeholder: String,
            label: String
        },
        email: {
            placeholder: String,
            label: String
        },
    },
    aboutYourOrg: {
        title: String,
        companyName: {
            placeholder: String,
            label: String
        },
        industry: {
            placeholder: String,
            label: String
        },
        state: {
            placeholder: String,
            label: String
        },
        city: {
            placeholder: String,
            label: String
        },
        country: {
            label: String,
            placeholder: String
        },
        source: {
            label: String,
            placeholder: String
        },
    },
    aboutLocationForThisProduct: {
        title: String,
        address: {
            label: String,
            placeholder: String
        },
        addressAdditional: {
            label: String,
            placeholder: String
        },
        city: {
            label: String,
            placeholder: String
        },
        state: {
            label: String,
            placeholder: String
        },
        country: {
            label: String,
            placeholder: String
        },
        zip: {
            label: String,
            placeholder: String
        },
    },
    checkbox: String,
    button: {
        text: String
    }
}
